import { Button, Modal, TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import { makeToasterErrorHandler } from "../../common/http/makeToasterErrorHandler";
import { usePageToast } from "../../hooks/usePageToast";
import api from "../../services/api";
import PageToaster from "../toaster/PageToaster";

interface ServiceCreateModalProps {
  open: boolean;
  onClose: () => void;
  onServiceCreated: () => void;
  deviceId?: number;
  workOrderId?: string;
  serviceToEdit?: any; // Novo: serviço que queremos editar (opcional)
}

const ServiceCreateModal: React.FC<ServiceCreateModalProps> = ({
  open,
  onClose,
  onServiceCreated,
  deviceId,
  workOrderId,
  serviceToEdit
}) => {
  const [serviceName, setServiceName] = useState("");
  const [serviceDescription, setServiceDescription] = useState("");
  const [serviceCost, setServiceCost] = useState<number>(0);

  const containerId = "toaster-service-create-modal";
  const { autoSuccess, autoError, autoInfo, autoWarn } = usePageToast(
    containerId,
    true
  );

  const handleHttpError = makeToasterErrorHandler(autoError);

  // Quando abrir o modal, se for edição, já preenche os campos
  useEffect(() => {
    if (serviceToEdit) {
      setServiceName(serviceToEdit.service_performed_name);
      setServiceDescription(serviceToEdit.service_performed_description);
      setServiceCost(serviceToEdit.service_performed_cost);
    } else {
      setServiceName("");
      setServiceDescription("");
      setServiceCost(0);
    }
  }, [serviceToEdit, open]);

  const handleSubmit = async () => {
    if (!serviceName || !serviceDescription) {
      autoError("Preencha todos os campos obrigatórios.");
      return;
    }

    try {
      if (serviceToEdit) {
        // 🚀 Atualizar o serviço
        await api.put(
          `/service-performed/${serviceToEdit.service_performed_id}`,
          {
            service_performed_name: serviceName,
            service_performed_description: serviceDescription,
            service_performed_cost: serviceCost
          }
        );

        autoSuccess("Serviço atualizado com sucesso!");
      } else {
        // 🚀 Criar novo serviço + associar
        const { data: serviceSaved } = await api.post("/service-performed", {
          service_performed_name: serviceName,
          service_performed_description: serviceDescription,
          service_performed_cost: serviceCost
        });

        await api.post(
          `/work-order/${workOrderId}/device/${deviceId}/service/${serviceSaved.service_performed_id}`,
          {}
        );

        autoSuccess("Serviço cadastrado e associado com sucesso!");
      }

      onServiceCreated();
      onClose();
    } catch (error) {
      handleHttpError(error);
      console.error("Erro ao salvar serviço:", error);
    }
  };

  return (
    <>
      <PageToaster containerId={containerId} />
      <Modal open={open} onClose={onClose} aria-labelledby="service-modal">
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            backgroundColor: "var(--surface)",
            border: "1px solid var(--border-strong)",
            color: "var(--text)",
            padding: "20px",
            borderRadius: "8px",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
            width: "500px",
            maxHeight: "90vh",
            overflowY: "auto"
          }}
        >
          <h2>{serviceToEdit ? "Editar Serviço" : "Novo Serviço"}</h2>

          <TextField
            fullWidth
            label="Nome do Serviço"
            value={serviceName}
            onChange={(e) => setServiceName(e.target.value)}
            margin="normal"
          />

          <TextField
            fullWidth
            label="Descrição do Serviço"
            value={serviceDescription}
            onChange={(e) => setServiceDescription(e.target.value)}
            margin="normal"
          />

          <TextField
            fullWidth
            label="Custo do Serviço (R$)"
            type="number"
            value={serviceCost}
            onChange={(e) => setServiceCost(parseFloat(e.target.value))}
            margin="normal"
          />

          <div style={{ marginTop: "20px", textAlign: "right" }}>
            <Button
              onClick={onClose}
              style={{ marginRight: "10px" }}
              color="secondary"
            >
              Cancelar
            </Button>
            <Button onClick={handleSubmit} color="primary" variant="contained">
              {serviceToEdit ? "Atualizar" : "Cadastrar"}
            </Button>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default ServiceCreateModal;
